import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from 'react-router-dom';
import { useHistory } from "react-router-dom";
import axios from "axios";
import { SET_INPROGRESS_ORDERS } from "../../redux/actions/inprogressOrdes";
import { useSite } from "../../_foundation/hooks/useSite";
import useTabVisibility from "../../_foundation/hooks/use-tab-active";
import NotificationsIcon from '@material-ui/icons/Notifications';
import * as ROUTES from "../../constants/routes";
import { Badge } from "@material-ui/core";
import { StyledGrid } from "../elements";
import styled from "styled-components";

export const StyledGridContainer = styled(StyledGrid)`
  ${({ theme }) => `
   
  &.container-notificaciones {
    padding-left: 10px;
    cursor: pointer;
  }

    .badge-color {
        .MuiBadge-colorSecondary {
            color: #fff;
            background-color: #d14e4e;
        }
    }
  
  `}
`;


const Notifications = () => {

    const { mySite } = useSite();
    const [invisible, setInvisible] = useState(true);
    const [notifications, setNotifications] = useState(0);
    const history = useHistory();
    const dispatch = useDispatch();
    const location = useLocation();
    useTabVisibility(() => {
        if(location.pathname !== ROUTES.INPROGRESS_ORDERS) {
            getNotifications();
        }
    });

    
    useEffect(() => {
        if(location.pathname !== ROUTES.INPROGRESS_ORDERS) {
            getNotifications();
        }

    }, [])

    useEffect(() => {
      
        switch (location.pathname) {
            case ROUTES.INPROGRESS_ORDERS:
                setNotifications(0);
                setInvisible(true);
                break;
            case ROUTES.CART:
                getNotifications();
                break;
            case ROUTES.DASHBOARD:
                getNotifications();
                break;
        
            default:
                break;
        }
    
    }, [location.pathname])

    
    

    const getNotifications = () => {
        axios.get(`/wcs/resources/store/${mySite.storeID}/dpcatalogo/orders`)
            .then((data) => {
                if(data.data && data.data?.orders?.length > 0) {
                    setNotifications(data.data.orders.length);
                    setInvisible(false);
                    const ordersId = data.data.orders.map((order: any) => order.orderId);
                    dispatch(SET_INPROGRESS_ORDERS(ordersId));
                } else {
                    setNotifications(0);
                    setInvisible(true);
                    dispatch(SET_INPROGRESS_ORDERS([]));
                }
            })
            .catch((error) => {
                // dispatch(SET_INPROGRESS_ORDERS([]));
            });
    }

    const goInProgressOrders = () => {
        history.push(ROUTES.INPROGRESS_ORDERS);
        setNotifications(0);
        setInvisible(true);
    }

  return (
    <StyledGridContainer item className="container-notificaciones">
        <Badge
        color="secondary"
        invisible={invisible}
        badgeContent={notifications}
        anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',
        }}
        onClick={goInProgressOrders}
        className="badge-color"
        >
            <NotificationsIcon className="iconNotificaciones"/>
        </Badge>
    </StyledGridContainer>
  );
}

export default Notifications;